<script lang="ts">
    import type {CssSize} from 'shared/ui-widgets/types';
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import {exists} from 'shared/utils/custom-utils';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let icon: UIcons | null = null;
    export let trailingIcon: UIcons | null = null;
    export let iconColor = 'inherit';
    export let orientation: 'vertical' | 'horizontal' = 'horizontal';
    export let align: 'start' | 'center' | 'end' = 'center';
    export let textAlign: 'start' | 'center' | 'end' = 'center';
    export let justify: 'start' | 'center' | 'end' = 'center';
    export let iconLineHeight = 'inherit';
    export let gap: CssSize = '1ch';
    export let additionalClasses = '';
</script>

<div class="iconed-content {orientation} {additionalClasses}"
     style="--align: {align}; --justify: {justify}; --textAlign: {textAlign}; --gap: {gap};">

    {#if exists(icon)}
        <UIcon {icon} color="{iconColor}" lineHeight="{iconLineHeight}"/>
    {/if}

    {#if $$slots.default}
        <slot/>
    {/if}

    {#if exists(trailingIcon)}
        <UIcon icon="{trailingIcon}" color="{iconColor}" lineHeight="{iconLineHeight}"/>
    {/if}
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .iconed-content {
        display: flex;
        gap: var(--gap);
        align-items: var(--align);
        justify-content: var(--justify);
        text-align: var(--textAlign);

        &.vertical {
            flex-direction: column;
        }
    }
</style>